import React from 'react';

import { SkeletonItem } from 'app/components/DetailsPages/shared/styled';

import { IResource } from '../../ResourceCard';
import ResourceDetailEdit from '../ResourceDetailEdit';
import ContributorsWithCompanies from './ContributorsWithCompanies';
import { ResourceContributorsSubmitterWrapper } from './styled';

interface ResourceContributorsProps {
  resource: IResource;
  preventShowEditing?: boolean;
}

export default function ResourceContributors({
  resource,
  preventShowEditing = false,
}: ResourceContributorsProps) {
  return (
    <>
      <ResourceContributorsSubmitterWrapper
        justifyContent={
          resource?.contributors?.companies?.length > 0 ? 'space-between' : 'flex-end'
        }
      >
        {resource?.contributors?.companies?.length > 0 ? (
          <ContributorsWithCompanies resource={resource} />
        ) : null}
        {!preventShowEditing ? <ResourceDetailEdit /> : null}
      </ResourceContributorsSubmitterWrapper>
    </>
  );
}

ResourceContributors.Skeleton = function ResourceContributorsSkeleton() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '11px' }}>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '12px' }}>
        <div
          style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '11px' }}
        >
          <SkeletonItem animated style={{ width: '72px', height: '72px', borderRadius: '100%' }} />
        </div>
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '11px',
          }}
        >
          <SkeletonItem animated style={{ width: '100%', height: '20px', borderRadius: '8px' }} />
          <SkeletonItem animated style={{ width: '50%', height: '20px', borderRadius: '8px' }} />
        </div>
      </div>
      <SkeletonItem animated style={{ width: '100%', height: '20px', borderRadius: '8px' }} />
    </div>
  );
};
